/**
 * Validation class
 */
var Validation = /** @class */ (function () {
    function Validation() {
    }
    /**
     * Validates the given email address
     * @param str {string} - email string
     * @returns {string} - email
     */
    Validation.prototype.email = function (str) {
        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(String(str).toLowerCase());
    };
    Validation.prototype.required = function (value) {
        return !!value;
    };
    return Validation;
}());
;
var Validate = new Validation();
export default Validate;
